import { Box, styled } from "@mui/material";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";

export const StyledTransactionBox = styled(Box)(({ theme }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    backgroundColor: colors.white,
    borderRadius: "8px",
    padding: theme.spacing(1.5, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1.5, 2),
    },
  };
});
